import React, { Component } from 'react'
import { Layer } from 'react-konva'
import { KonvaEventObject } from 'konva/lib/Node'
import ImageElement from './Element/ImageElement'
import TextElement from './Element/TextElement'
import BarcodeElement from './Element/BarcodeElement'
import { Element } from '../../views/LabelBuilder/LabelBuilder.slice'
import LineElement from './Element/LineElement'
import CircleElement from './Element/CircleElement'
import RectElement from './Element/RectElement'
import EllipseElement from './Element/EllipseElement'
import WedgeElement from './Element/WedgeElement'
import RingElement from './Element/RingElement'
import ArcElement from './Element/ArcElement'
import ArrowElement from './Element/ArrowElement'
import Konva from 'konva';


interface Props {
  elements: Element[],
  onElementClick: (event: KonvaEventObject<MouseEvent>) => void,
  onElementTransform: (event: KonvaEventObject<MouseEvent>) => void,
  onElementDrag: (event: KonvaEventObject<DragEvent>) => void,
  onElementRightClick: (event: KonvaEventObject<PointerEvent>) => void,
  onTextUpdate: (id: string, textNode: Konva.Text, newText: string) => void
}

export default class Elements extends Component<Props> {
  render () {
    return (
      <Layer id="elements">
          {this.props.elements.map(element => {
            switch (element.type) {
              case 'image': {
                return (
                  <ImageElement
                    key={element.id}
                    element={element}
                    onClick={this.props.onElementClick}
                    onTransform={this.props.onElementTransform}
                    onDrag={this.props.onElementDrag}
                    onRightClick={this.props.onElementRightClick} />
                )
              }
              case 'text': {
                return (
                  <TextElement
                    key={element.id}
                    element={element}
                    onClick={this.props.onElementClick}
                    onTransform={this.props.onElementTransform}
                    onDrag={this.props.onElementDrag}
                    onRightClick={this.props.onElementRightClick} 
                    onTextUpdate={this.props.onTextUpdate} />
                )
              }
              case 'barcode': {
                return (
                  <BarcodeElement
                    key={element.id}
                    element={element}
                    onClick={this.props.onElementClick}
                    onTransform={this.props.onElementTransform}
                    onDrag={this.props.onElementDrag}
                    onRightClick={this.props.onElementRightClick} />
                )
              }
              case 'line': {
                return (
                  <LineElement
                    key={element.id}
                    element={element}
                    onClick={this.props.onElementClick}
                    onTransform={this.props.onElementTransform}
                    onDrag={this.props.onElementDrag}
                    onRightClick={this.props.onElementRightClick} />
                )
              }
              case 'circle': {
                return (
                  <CircleElement
                    key={element.id}
                    element={element}
                    onClick={this.props.onElementClick}
                    onTransform={this.props.onElementTransform}
                    onDrag={this.props.onElementDrag} 
                    onRightClick={this.props.onElementRightClick}/>
                )
              }
              case 'rect': {
                return (
                  <RectElement
                    key={element.id}
                    element={element}
                    onClick={this.props.onElementClick}
                    onTransform={this.props.onElementTransform}
                    onDrag={this.props.onElementDrag}
                    onRightClick={this.props.onElementRightClick} />
                )
              }
              case 'ellipse': {
                return (
                  <EllipseElement
                    key={element.id}
                    element={element}
                    onClick={this.props.onElementClick}
                    onTransform={this.props.onElementTransform}
                    onDrag={this.props.onElementDrag}
                    onRightClick={this.props.onElementRightClick} />
                )
              }
              case 'wedge': {
                return (
                  <WedgeElement
                    key={element.id}
                    element={element}
                    onClick={this.props.onElementClick}
                    onTransform={this.props.onElementTransform}
                    onDrag={this.props.onElementDrag}
                    onRightClick={this.props.onElementRightClick} />
                )
              }
              case 'ring': {
                return (
                  <RingElement
                    key={element.id}
                    element={element}
                    onClick={this.props.onElementClick}
                    onTransform={this.props.onElementTransform}
                    onDrag={this.props.onElementDrag}
                    onRightClick={this.props.onElementRightClick} />
                )
              }
              case 'arc': {
                return (
                  <ArcElement
                    key={element.id}
                    element={element}
                    onClick={this.props.onElementClick}
                    onTransform={this.props.onElementTransform}
                    onDrag={this.props.onElementDrag}
                    onRightClick={this.props.onElementRightClick} />
                )
              }
              case 'arrow': {
                return (
                  <ArrowElement
                    key={element.id}
                    element={element}
                    onClick={this.props.onElementClick}
                    onTransform={this.props.onElementTransform}
                    onDrag={this.props.onElementDrag}
                    onRightClick={this.props.onElementRightClick} />
                )
              }

              default: {
                return null
              }
            }
          })
        }
      </Layer>
    )
  }
}
